import classnames from 'classnames';
import React, { FunctionComponent, HTMLAttributes, } from 'react';

import classes from './styles/press_release_message.module.scss';

interface PressReleaseMessageProps extends HTMLAttributes<HTMLParagraphElement> {
  showIcon?: boolean;
}

const defaultMessage = bfTranslate('Something went wrong. Try again.');

export const PressReleaseMessage: FunctionComponent<PressReleaseMessageProps> = (props) => {
  const { children, className, showIcon = true, ...otherProps } = props;

  return (
    <p {...otherProps} className={classnames(classes.message, className)}>
      {showIcon && (
        <span className={classnames("bff-warning", classes.messageIcon)} />
      )}
      <span>{children || defaultMessage}</span>
    </p>
  );
};
